import find from 'lodash/find';
import get from 'lodash/get';
import includes from 'lodash/includes';
import map from 'lodash/map';
import reduce from 'lodash/reduce';
import some from 'lodash/some';
// Radius of the Earth in km
const EARTH_RADIUS = 6371;
const DEFAULT_DISTANCE = 0.01;
function deg2rad(deg) {
    return deg * (Math.PI / 180);
}
export function getDistanceFromLatLngInKm({ firstPairs, secondPairs }) {
    if (!firstPairs.lat || !firstPairs.lng || !secondPairs.lat || !secondPairs.lng) {
        return undefined;
    }
    const dLat = deg2rad(secondPairs.lat - firstPairs.lat);
    const dLng = deg2rad(secondPairs.lng - firstPairs.lng);
    const firstPart = Math.sin(dLat / 2) * Math.sin(dLat / 2);
    // eslint-disable-next-line max-len
    const secondPart = Math.cos(deg2rad(firstPairs.lat)) *
        Math.cos(deg2rad(secondPairs.lat)) *
        Math.sin(dLng / 2) *
        Math.sin(dLng / 2);
    const result = firstPart + secondPart;
    const c = 2 * Math.atan2(Math.sqrt(result), Math.sqrt(1 - result));
    // Distance in km
    const d = EARTH_RADIUS * c;
    const distance = Number(d.toFixed(2));
    return distance === 0 ? DEFAULT_DISTANCE : distance;
}
// todo: md: rename to getDistanceToDealers
export const addDistanceToDealers = (dealers, toPlace) => map(dealers, (item) => ({
    ...item,
    distance: getDistanceFromLatLngInKm({
        firstPairs: toPlace,
        secondPairs: {
            lat: item.latitude,
            lng: item.longitude,
        },
    }) ?? 0,
}));
export const getDealerById = (dealers, id) => find(dealers, ({ vicinityId }) => vicinityId === id) || null;
const getServiceNamesForDealer = (dealer, services) => map(dealer?.serviceIds, (serviceId) => get(find(services, {
    serviceId,
}), ['serviceName'], serviceId));
const getCategoryPropForDealer = (dealer, categories, prop) => reduce(categories, (acc, category) => {
    if (some(category.services, ({ serviceId }) => includes(dealer?.serviceIds, serviceId))) {
        return [...acc, category[prop]];
    }
    return acc;
}, []);
export const getDealerWithCategoriesServices = (dealers, allCategories) => {
    const allServices = reduce(allCategories, (acc, curr) => [...acc, ...curr.services], []);
    return map(dealers, (dealer) => {
        const services = getServiceNamesForDealer(dealer, allServices);
        const categories = getCategoryPropForDealer(dealer, allCategories, 'categoryName');
        const categoryIds = getCategoryPropForDealer(dealer, allCategories, 'categoryId');
        return {
            ...dealer,
            distance: 0,
            services,
            categoriesIntl: map(categoryIds, (_, i) => categories[i]),
            servicesIntl: map(dealer.serviceIds, (_, i) => services[i]),
            categories,
            categoryIds,
        };
    });
};
export const filterCategoriesByExistedDealers = ({ categories, dealers, }) => {
    return categories.filter((category) => category.services.some((service) => dealers.some((dealer) => dealer.serviceIds.includes(service.serviceId))));
};
export const filterDealersBySelectedCategory = ({ category, dealers, }) => {
    return dealers.filter((dealer) => category.services.some((service) => dealer.serviceIds.includes(service.serviceId)));
};
